import { cn } from "@omni/utils/styles";
import { useId } from "react";

type StarProps = {
    value: number;
    size: number;
};

const Star = ({ value, size }: StarProps) => {
    const id = useId();

    return (
        <svg
            key={id}
            width={size}
            height={size}
            viewBox={"0 0 32 32"}
            fill={"none"}
        >
            {/* Background star */}
            <path
                d="M16.3076923,1.76513255 L20.8381599,11.4172719 L31.0592597,12.978917 L23.6603835,20.5621906 L25.3975353,31.2117909 L16.3076923,26.1870493 L7.21784935,31.2117909 L8.95500108,20.5621906 L1.55612493,12.978917 L11.7772247,11.4172719 L16.3076923,1.76513255 Z"
                className={cn("tw:fill-grey-light")}
            />
            {/* Filled portion */}
            <defs>
                <clipPath id={`rating__star__clip-${id}`}>
                    <rect
                        x={"0"}
                        y={"0"}
                        width={`${value * 100}%`}
                        height={"100%"}
                    />
                </clipPath>
            </defs>
            <path
                d="M16.3076923,1.76513255 L20.8381599,11.4172719 L31.0592597,12.978917 L23.6603835,20.5621906 L25.3975353,31.2117909 L16.3076923,26.1870493 L7.21784935,31.2117909 L8.95500108,20.5621906 L1.55612493,12.978917 L11.7772247,11.4172719 L16.3076923,1.76513255 Z"
                clipPath={`url(#rating__star__clip-${id})`}
                className={cn("tw:fill-rating")}
            />
        </svg>
    );
};

export { Star };
